export const INTEGRATE_GOOGLE_ANALYTICS =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ANALYTICS/INTEGRATE'
export const INTEGRATE_GOOGLE_ANALYTICS_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ANALYTICS/INTEGRATE_SUCCESS'
export const INTEGRATE_GOOGLE_ANALYTICS_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ANALYTICS/GOOGLE_ANALYTICS/INTEGRATE_ERROR'
